import { useState, type FormEvent } from "react";
import { api, type PublicUser } from "../../lib/api";

export function LoginPage({ onSuccess }: { onSuccess: (u: PublicUser) => void }) {
  const [email, setEmail] = useState("admin@localhost");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await api.login(email.trim(), password);
      onSuccess(res.user);
    } catch (err) {
      const msg = err instanceof Error ? err.message : "Login failed";
      setError(
        /failed to fetch/i.test(msg)
          ? "Connessione API fallita. Ricarica https://box.wiumail.com/login/ con Ctrl+Shift+R."
          : msg,
      );
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="auth-shell">
      <div className="auth-stage" aria-hidden>
        <div className="auth-orb auth-orb-a" />
        <div className="auth-orb auth-orb-b" />
        <div className="auth-grid" />
      </div>
      <div className="auth-card">
        <div className="brand brand-lg">
          <span className="brand-mark">M</span>
          <div className="brand-text">
            <strong>Mailstorm</strong>
            <em>Webmail multi-account</em>
          </div>
        </div>
        <h1>Accedi</h1>
        <p className="auth-lead">
          Un client professionale per Gmail, Microsoft e IMAP — stile SnappyMail / Roundcube Elastic.
        </p>
        <form className="form" onSubmit={submit}>
          <div>
            <label className="label" htmlFor="email">
              Email
            </label>
            <input
              id="email"
              className="input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="username"
              required
            />
          </div>
          <div>
            <label className="label" htmlFor="password">
              Password
            </label>
            <input
              id="password"
              className="input"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>
          <div className="error">{error}</div>
          <button className="btn btn-primary btn-block" type="submit" disabled={loading}>
            {loading ? "Accesso…" : "Entra in Mailstorm"}
          </button>
        </form>
      </div>
    </div>
  );
}
